import { useState, useEffect } from 'react';
import { ICandidate, AISmartSourceSearch, getAISmartSourceMapped } from 'wisestep-api';

export interface IKeys {
  [key: string]: string;
}
interface AISourceMappedProps {
  sourceMapped: AISmartSourceSearch;
  keys: string[];
}
const useAISmartSourceMapped = (candidates: ICandidate[], jobId): AISourceMappedProps => {
  const [state, setState] = useState<AISourceMappedProps>({
    sourceMapped: { links: [], jobId: '' },
    keys: [],
  });
  useEffect(() => {
    let keys: string[] = [];
    candidates?.forEach((candidate) => {
      candidate.email && keys.push(candidate.email);
      candidate.linkedInURL && keys.push(candidate.linkedInURL);
      candidate.phoneNumber && keys.push(candidate.phoneNumber);
      candidate.passportNumber && keys.push(candidate.passportNumber);
      if (candidate.socialUrls && candidate.socialUrls.length > 0) {
        keys = keys.concat(candidate.socialUrls);
      }
    });
    (async () => {
      const payload: AISmartSourceSearch = {
        links: keys,
        jobId: jobId,
      };
      const response = await getAISmartSourceMapped(payload);
      const mappedData = response.data;
      setState({ sourceMapped: mappedData, keys: mappedData?.links?.map(({ key }) => key) });
    })();
  }, [candidates, jobId]);

  return state;
};
export default useAISmartSourceMapped;
